export const getColorStyle = (value: number) => {
  if (value <= 6) return "red";
  if (value <= 8) return "yellow";
  if (value <= 10) return "darkgreen";
  return "darkgreen";
};

export const csatRatings = [
  { value: 1, className: "fa fa-angry red" },
  { value: 2, className: "fa fa-frown orange" },
  { value: 3, className: "fa fa-meh yellow" },
  { value: 4, className: "fa fa-smile green" },
  { value: 5, className: "fa fa-grin-stars darkgreen" },
];
